import React from 'react';
import './Wishlist.scss';
import { useSelector } from 'react-redux';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const Wishlist = () => {
  const wishlist = useSelector(state => state?.header?.mainNavigationData?.wishlist);
  const wishlistCount = useSelector(state => state?.common?.isWishlistCount);

  if (wishlist) {
    return (
      <a
        className="odWishlist"
        href={wishlist.link}
        onClick={() => triggerDataLayerOnCtaClick('wishlist')}
      >
        {wishlistCount > 0 && <span className="odWishlist__count">{wishlistCount}</span>}
        <img alt={wishlist.alt} className="odWishlist__icon" src={wishlist.src} />
      </a>
    );
  }

  return null;
};

export default Wishlist;
